<template>
  <div>
    <panel-description
      :paymentMethodName="paymentMethodName"
      :virtualAccountNumber="paymentCode"
      :viewMybookingUrl="viewMybookingUrl"
      :price="price"
      :orderNumber="orderNumber"
    />
    <div class="container py-3" id="checkout-thankyou">
      <countdown :paymentDueDiff="paymentDueDiff" class="mt-4"></countdown>
      <panel-steps
        :content="content"
        :viewMybookingUrl="viewMybookingUrl"
        v-if="content"
      ></panel-steps>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Countdown from '@/components/how-to-pay/partials/countdown';
import PanelDescription from '@/components/how-to-pay/partials/panel-description';
import PanelSteps from '@/components/how-to-pay/partials/panel-steps';
export default {
  name: 'alfa',
  props: [
    'paymentMethodName',
    'price',
    'paymentCode',
    'viewMybookingUrl',
    'orderNumber',
    'paymentDueDiff',
  ],
  components: {
    PanelDescription,
    Countdown,
    PanelSteps,
  },
  data: () => ({
    content: null,
  }),
  computed: {
    ...mapState({
      bookingOrder: (state) => state.v2.booking.bookingOrder,
    }),
  },
  mounted() {
    this.content = {
      tabs: [
        {
          title: 'Via Alfamart / Alfamidi / Dan+Dan',
          steps: [
            this.$t('booking.guide.alfa.msg1'),
            this.$t('booking.guide.alfa.msg2'),
            this.$t('booking.guide.alfa.msg3'),
            this.$t('booking.guide.alfa.msg4'),
          ],
        },
      ],
    };
  },
};
</script>

<style scoped></style>
